function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_753",
  d: "M13.5 2A8.444 8.444 0 0 0 5 10.4C5 16.7 13.5 26 13.5 26S22 16.7 22 10.4A8.444 8.444 0 0 0 13.5 2zm-6.071 8.4a6.072 6.072 0 0 1 12.143 0c0 3.456-3.5 8.628-6.071 11.856-2.527-3.204-6.072-8.436-6.072-11.856z",
  className: "cls-1",
  transform: "translate(-5 -2)"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  id: "\\uD0C0\\uC6D0_111",
  cx: 3.036,
  cy: 3,
  className: "cls-1",
  rx: 3.036,
  ry: 3,
  transform: "translate(5.464 5.4)"
});

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_location",
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.055fc306.svg";
export { ForwardRef as ReactComponent };